import PermissionsModel, { PermissionsFilters } from "../models/permissions.model";
import { PermissionsType } from "../types/permissions";
import { useReducerAsState } from "./useReducerAsState";

interface State {
    loading: boolean;
    error: string;
    permissions : Array<PermissionsType>;
    totalPermissions: number;
}

const usePermissions = () => {
    const [state, setState] = useReducerAsState<State>({
        permissions: [],
        loading: false,
        error: "",
        totalPermissions: 0
    })

    const { permissions, totalPermissions } = state

    const fetchPermissions = async (filters: PermissionsFilters) => {
        setState({ loading: true, error: "" })
        const response = await PermissionsModel.getAll(filters)
        if(response.error){
            setState({ error: response.error, loading: false, totalPermissions: 0, permissions: [] })
            return
        }

        setState({ permissions: response.permissions?.data, totalPermissions: response.total, error: "", loading: false})
    }

    return {
        permissions,
        totalPermissions,
        fetchPermissions,
    }

}

export default usePermissions;